import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import Footer from "@/components/Footer";
import ConnieWidget from "@/components/ConnieWidget";
import BottomTabBar from "@/components/BottomTabBar";
import TestModeBanner from "@/components/TestModeBanner";
import PromoBanners from "@/components/PromoBanners";
import DeactivatedBanner from "@/components/DeactivatedBanner";
import CoreGate from "@/components/CoreGate";
import GetAppBanner from "@/components/GetAppBanner";
import SmartAppBanner from "@/components/SmartAppBanner";
import MobileKeyboardHelper from "@/components/MobileKeyboardHelper";
import { useSidebarCollapsed } from "@/hooks/useSidebarCollapsed";

export default function Layout() {
  const { user } = useAuth();
  const location = useLocation();
  const [collapsed] = useSidebarCollapsed();
  // A brand-new salesperson is gated until they finish their C.O.R.E. assessment.
  const gatedSalesman = user?.role === "salesman" && !user?.core_done && !user?.impersonating;
  // On the assessment page a gated rep gets a chrome-free, immersive experience (no header/nav).
  const immersive = gatedSalesman && location.pathname.replace(/\/+$/, "") === "/core-assessment";
  const showChrome = user && !immersive;

  return (
    <div className="min-h-screen flex flex-col bg-[#0F172A]">
      {!immersive && <SmartAppBanner />}
      {/* Tablet + desktop: fixed left sidebar (ZenCRM-style). Phones keep the top bar + bottom tabs. */}
      {showChrome && <Sidebar />}
      <div className={`flex flex-col flex-1 min-h-screen transition-[padding] duration-200 ${showChrome ? (collapsed ? "md:pl-16" : "md:pl-60") : ""}`}>
        {showChrome && <div className="md:hidden"><Header /></div>}
        {showChrome && <PromoBanners />}
        {showChrome && <DeactivatedBanner />}
        {showChrome && <TestModeBanner />}
        {showChrome && <GetAppBanner />}
        <main className="flex-1 pb-28 md:pb-0">
          <Outlet />
        </main>
        {!user && <Footer />}
      </div>
      {showChrome && <BottomTabBar />}
      {showChrome && <MobileKeyboardHelper />}
      {!immersive && <ConnieWidget />}
      <CoreGate />
    </div>
  );
}
